import DashboardLayout from "cxfcomponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "cxfcomponents/Navbars/DashboardNavbar";
import SoftBox from "components/SoftBox";
import Card from "@mui/material/Card";
import SoftTypography from "components/SoftTypography";
import { useNavigate } from "react-router-dom";
import StatusBadge from "cxfcomponents/StatusBadge";
import { FlowTabs } from "./components/tabs";
import "./style.css";
import { getLocalDateTimeString, formatDateAndTime } from "helpers/common";
import defaultConnectorIcon from "assets/images/connector-list-view.svg";
import { ConnectorOptions } from "./components/options";
import { useSlugConnector } from "hooks/useSlugConnector";
import DefaultUserAvatar from "layouts/pages/account/components/Header/components/DefaultUserAvatar";
import { useSelector } from "react-redux";
import { useResourceListener } from "hooks/useResourceListener";

export const LibraryConnector = () => {
   const navigate = useNavigate();
   const { users } = useSelector((store) => store.portal.users);
   const { connector, handleFetchOwnedConnectors } = useSlugConnector();
   useResourceListener("connectorsSharingUpdate", handleFetchOwnedConnectors);

   const getOwnerDeveloper = () => {
      const connectorId = connector?.created_by_id;
      const createdByUser = users.find((user) => user.auth0_id === connectorId);

      if (createdByUser) {
         return {
            first_name: createdByUser?.first_name,
            last_name: createdByUser?.last_name,
            image: createdByUser?.image
         };
      }

      return null;
   };

   if (!connector) return <></>;

   const ownerDeveloper = getOwnerDeveloper();
   return (
      <>
         <div
            style={{
               padding: "8px",
               position: "sticky",
               top: 0,
               zIndex: 1000,
               backgroundColor: "var(--main-bg-color)"
            }}
         >
            <DashboardNavbar title={connector.name ?? ""} />
         </div>
         <DashboardLayout
            sx={{
               display: "flex",
               flexDirection: "column",
               minHeight: "100vh",
               height: "100vh",
               boxSizing: "border-box",
               overflow: "hidden"
            }}
         >
            <SoftBox
               mt={-3}
               sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  minHeight: 0
               }}
            >
               <Card
                  className="flow"
                  sx={{
                     backgroundColor: "transparent !important",
                     overflow: "hidden",
                     boxShadow: "none !important",
                     display: "flex",
                     flexDirection: "column",
                     flex: 1,
                     minHeight: 0
                  }}
               >
                  <Card
                     sx={{
                        overflow: "visible",
                        display: "flex",
                        flexDirection: "column",
                        flex: 1,
                        minHeight: 0
                     }}
                  >
                     {/* Top Part */}
                     <SoftBox
                        alignItems="flex-start"
                        justifyContent="space-between"
                        sx={{
                           display: {
                              sm: "block",
                              lg: "flex"
                           },
                           padding: {
                              sm: "12px 32px 20px 32px",
                              lg: "48px 64px 46px 64px"
                           },
                           flexWrap: {
                              sm: "wrap",
                              lg: "noWrap"
                           },
                           columnGap: "40px",
                           height: "max-content"
                        }}
                     >
                        <SoftBox display="flex" alignItems="flex-start" sx={{ marginBottom: { sm: "16px", lg: "0" }, position: "relative" }}>
                           {/* Go Back Button just above the connector logo */}
                           <SoftBox sx={{ position: "absolute", top: "-32px", left: 0 }}>
                              <button
                                 onClick={() => navigate("/workspace/connectors")}
                                 style={{
                                    alignItems: "center",
                                    background: "transparent",
                                    border: "none",
                                    cursor: "pointer",
                                    display: "flex",
                                    maxWidth: "max-content",
                                    fontSize: "14px",
                                    padding: 0
                                 }}
                              >
                                 <SoftBox
                                    sx={{
                                       display: "grid",
                                       marginRight: "16px",
                                       placeContent: "center",
                                       fontSize: "28px",
                                       fontWeight: "300"
                                    }}
                                 >
                                    <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                       <path d="M8.77783 0.5L0.999657 8.27817L8.77783 16.0563" stroke="#7B809A" />
                                    </svg>
                                 </SoftBox>
                                 <SoftTypography sx={{ fontWeight: "normal", fontSize: "14px" }}>Go back</SoftTypography>
                              </button>
                           </SoftBox>
                           <SoftBox
                              component="img"
                              borderRadius="16px"
                              marginRight="40px"
                              sx={{
                                 width: {
                                    sm: "120px",
                                    lg: "174px"
                                 },
                                 minHeight: {
                                    sm: "120px",
                                    lg: "164px"
                                 },
                                 maxHeight: {
                                    sm: "120px",
                                    lg: "164px"
                                 }
                                 //border: "0.5px solid #e6e6e6",
                              }}
                              src={connector.logo ? `${connector.logo}?v=${connector.updated_date_time ?? ""}` : defaultConnectorIcon}
                           />
                           <SoftBox
                              sx={{
                                 maxWidth: {
                                    lg: "clamp(100px, 32vw, 540px)"
                                 },
                                 display: "flex",
                                 flexDirection: "column",
                                 minHeight: "164px"
                              }}
                           >
                              <SoftTypography fontSize="24px" fontWeight="bold" lineHeight="1.25" marginBottom="8px" className="white-to-dark">
                                 {connector.name}
                              </SoftTypography>
                              <StatusBadge status={connector.status === "Active" ? "active" : connector.status} />
                              <SoftTypography sx={{ margin: "auto 0", fontSize: "13px" }}>{connector.description ? connector.description : "No description"}</SoftTypography>
                              <ConnectorOptions connector={connector} />
                           </SoftBox>
                        </SoftBox>
                        <SoftBox
                           sx={{
                              flexBasis: {
                                 lg: "max-content"
                              },
                              flexShrink: 0
                           }}
                        >
                           <SoftTypography sx={{ display: "flex", alignItems: "flexStart" }} className="white-to-dark" fontSize="12px" marginBottom="4px">
                              <span style={{ opacity: 0.6, width: "76px", display: "inline-block" }}>Date Created:</span>
                              <span
                                 style={{
                                    marginLeft: "10px",
                                    maxWidth: "100px",
                                    whiteSpace: "break-spaces"
                                 }}
                              >
                                 {formatDateAndTime(getLocalDateTimeString(connector.created_date_time)) || ""}
                              </span>
                           </SoftTypography>
                           <SoftTypography sx={{ display: "flex", alignItems: "flexStart" }} className="white-to-dark" fontSize="12px" marginBottom="4px">
                              <span style={{ opacity: 0.6, width: "76px", display: "inline-block" }}>Last Edited:</span>
                              <span
                                 style={{
                                    marginLeft: "10px",
                                    maxWidth: "100px",
                                    whiteSpace: "break-spaces"
                                 }}
                              >
                                 {(connector.updated_date_time && formatDateAndTime(getLocalDateTimeString(connector.updated_date_time))) || ""}
                              </span>
                           </SoftTypography>
                           <SoftBox display="flex" alignItems="center">
                              <SoftTypography className="white-to-dark" opacity={0.6} fontSize="12px">
                                 Developed By:
                              </SoftTypography>
                              {ownerDeveloper && (
                                 <>
                                    {ownerDeveloper.image && ownerDeveloper.image.trim() !== "" ? (
                                       <SoftBox
                                          component="img"
                                          src={ownerDeveloper.image}
                                          alt={`${ownerDeveloper.first_name} ${ownerDeveloper.last_name}`}
                                          sx={{
                                             width: "24px",
                                             height: "24px",
                                             borderRadius: "32px",
                                             border: ".5px solid white !important",
                                             objectFit: "cover",
                                             margin: "0 8px"
                                          }}
                                       />
                                    ) : (
                                       <DefaultUserAvatar
                                          firstName={ownerDeveloper.first_name}
                                          lastName={ownerDeveloper.last_name}
                                          variant={"rounded"}
                                          size="xs"
                                          border=".5px solid white !important"
                                          disableFocusListener={false}
                                          disableTouchListener={false}
                                          open={false}
                                       />
                                    )}
                                    <SoftTypography component="span" className="white-to-dark" fontSize="12px" sx={{ textDecoration: "underline" }}>
                                       {ownerDeveloper.first_name} {ownerDeveloper.last_name}
                                    </SoftTypography>
                                 </>
                              )}
                           </SoftBox>
                        </SoftBox>
                     </SoftBox>
                     {/* End of Top Part */}
                     <SoftBox sx={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
                        <FlowTabs />
                     </SoftBox>
                  </Card>
               </Card>
            </SoftBox>
         </DashboardLayout>
      </>
   );
};
